"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globals = void 0;
const interUrl = 'https://fonts.googleapis.com/css?family=Inter:300,300i,400,400i,500,500i,600,600i,700,700i&display=swap';
exports.globals = {
    font: {
        size: '16px',
        family: '"Inter", sans-serif',
        url: interUrl,
    },
    focus: {
        color: '#005CE4',
    },
    background: {
        color: '#E4EBF1',
    },
};
//# sourceMappingURL=globals.js.map